<template>
    <div class="popupover3 gtyTip" id="gtyTip" :class="{ active: isShow}">
        <div class="popupover3-bg" @click="onGoBack()"></div>
        <div class="gtyTip-m">
            <div class="gtyTip-close js-popupClose2" @click="onGoBack()"><img src="https://resource.rcclchina.com.cn/cruiseDetail/closed.png" /></div>
            <p class="gtyTip-title">如预订随机舱房，请注意：</p>
            <p>该房型在预订时暂无法确认具体房间类型及房间号，房间分配将根据航线实际售卖情况进行，开航前将在订单详情中更新为实际房型名称及房间号。请注意关注更新信息并打印最新在线值船行程单。</p>
            <p>*请注意该房型中随机阳台房/随机套房有可能会被分配至遮挡房型，房型/房源不可自主挑选；如介意遮挡房型，建议直接预订其他非遮挡房型以提升入住体验。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GtyPopup",
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
.popupover3 {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10200;
    display: none;
    width: 100%;
    height: 100%;
    .popupover3-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .gtyTip-m {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        -moz-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        width: 93%;
        padding: 20px;
        background: #fff;
        .gtyTip-close {
            position: absolute;
            top: 0;
            right: 0;
            width: 33px;
            height: 33px;
            padding: 5px;
            img {
                width: 100%;
            }
        }

        p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #000;
            font-size: 13px;
        }

        .gtyTip-title {
            font-weight: bold;
        }
    }
}

.popupover3.active {
    display: block;
}
</style>